import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from 'modules/snackbar'
import api from 'modules/api'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    modules: {
      snackbar: snackbar,
      api: api
    },
    state: {},

    actions: {},

    mutations: {},

    getters: {}
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js